import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "../components/sidebar";
import Notification from "../components/Notification";
import ProfileDropdown from "../components/ProfileDropdown";
import "../styles/PosPage.css";
import "../styles/Dashboard.css";

import Galon19L from "../assets/Galon19L.jpg";
import Galon15L from "../assets/Galon15L.jpeg";

const products = [
    { id: 1, name: "Galon 19L", price: 6000, priceDelivery: 7000, image: Galon19L },
    { id: 2, name: "Galon 15L", price: 5000, priceDelivery: 6000, image: Galon15L },
];

const PosPage = () => {
    const [cart, setCart] = useState([]);
    const [transactionsToday, setTransactionsToday] = useState([]);
    const [message, setMessage] = useState("");

    // Ambil username & token dari localStorage
    const username = localStorage.getItem("username");
    const token = localStorage.getItem("token");

    useEffect(() => {
        if (!username || !token) {
            console.warn("🚨 Tidak ada username atau token. Redirect ke login.");
            window.location.href = "/login";
            return;
        }
    }, [username, token]);

    const fetchTransactionsToday = useCallback(async () => {
        try {
            const response = await fetch(`https://depotaircerdas.com/api/sales/today/${username}?_t=${Date.now()}`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            });
    
            if (response.ok) {
                const data = await response.json();
                console.log("✅ Data transaksi terbaru setelah delete:", data); // Debugging
                setTransactionsToday(data);
            } else {
                console.error("❌ Gagal mengambil transaksi hari ini");
            }
        } catch (error) {
            console.error("❌ Gagal mengambil transaksi hari ini:", error);
        }
    }, [username, token]);
    
    

    useEffect(() => {
        fetchTransactionsToday();
    }, [fetchTransactionsToday]);

    const addToCart = (product, isDelivery) => {
        const price = isDelivery ? product.priceDelivery : product.price;
        const existingItemIndex = cart.findIndex(item => item.name === product.name && item.isDelivery === isDelivery);

        if (existingItemIndex !== -1) {
            const updatedCart = [...cart];
            updatedCart[existingItemIndex].quantity += 1;
            setCart(updatedCart);
        } else {
            const newItem = { ...product, isDelivery, price, quantity: 1 };
            setCart([...cart, newItem]);
        }
    };

    const removeFromCart = (index) => {
        const newCart = [...cart];
        if (newCart[index].quantity > 1) {
            newCart[index].quantity -= 1;
        } else {
            newCart.splice(index, 1);
        }
        setCart(newCart);
    };

    const getTotalPrice = () => {
        return cart.reduce((total, item) => total + item.price * item.quantity, 0);
    };

    const handleSaveTransaction = async () => {
        if (cart.length === 0) {
            setMessage("⚠️ Keranjang masih kosong!");
            return;
        }

        const transactionData = { username, cart };

        try {
            const response = await fetch("https://depotaircerdas.com/api/sales", {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(transactionData),
            });

            if (response.ok) {
                const result = await response.json();
                setMessage(`✅ Berhasil disimpan transaksi ke-${result.total_today} hari ini!`);
                setCart([]);
                fetchTransactionsToday();
            } else {
                setMessage("❌ Gagal menyimpan transaksi.");
            }
        } catch (error) {
            console.error("Error:", error);
            setMessage("❌ Terjadi kesalahan saat menyimpan transaksi.");
        }
    };

    const handleDeleteTransaction = async (transactionId) => {
        console.log("🔍 Menghapus transaksi ID:", transactionId, "Tipe:", typeof transactionId);
        
        try {
            const response = await fetch(`https://depotaircerdas.com/api/sales/${Number(transactionId)}`, {
                method: "DELETE",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
    
            if (response.ok) {
                console.log("✅ Transaksi berhasil dihapus, memperbarui daftar transaksi...");
                setMessage("🗑️ Transaksi berhasil dihapus!");
    
                // 🔄 Langsung update state dengan memfilter transaksi yang dihapus
                setTransactionsToday((prevTransactions) => 
                    prevTransactions.filter(item => item.transaction_id !== transactionId)
                );
    
                // 🔄 Ambil ulang daftar transaksi dari backend
                await fetchTransactionsToday();
            } else {
                const errorData = await response.json();
                console.error("❌ Gagal menghapus transaksi:", errorData);
                setMessage("❌ Gagal menghapus transaksi.");
            }
        } catch (error) {
            console.error("❌ Terjadi kesalahan saat menghapus transaksi:", error);
            setMessage("❌ Terjadi kesalahan saat menghapus transaksi.");
        }
    };
    
    
    
    
    

    return (
        <div className="pos-container">
            <div className="pos-header">
                <h2>Kasir - {username}</h2>
                <div className="header-right">
                    <Notification username={username} />
                    <ProfileDropdown username={username} />
                </div>
            </div>

            <Sidebar />

            <div className="pos-content">
                <div className="product-list">
                    {products.map((product) => (
                        <div key={product.id} className="product-card">
                            <img src={product.image} alt={product.name} />
                            <h4>{product.name}</h4>
                            <button onClick={() => addToCart(product, false)}>
                                Tidak Diantar - Rp {product.price.toLocaleString()}
                            </button>
                            <button onClick={() => addToCart(product, true)}>
                                Diantar - Rp {product.priceDelivery.toLocaleString()}
                            </button>
                        </div>
                    ))}
                </div>

                <div className="cart-section">
                    <h3>Keranjang</h3>
                    <ul>
                        {cart.map((item, index) => (
                            <li key={index}>
                                {item.name} ({item.isDelivery ? "Diantar" : "Tidak Diantar"}) - {item.quantity}x Rp {item.price.toLocaleString()}
                                <button className="remove-btn" onClick={() => removeFromCart(index)}>X</button>
                            </li>
                        ))}
                    </ul>
                    <h3>Total: Rp {getTotalPrice().toLocaleString()}</h3>
                    <button className="save-btn" onClick={handleSaveTransaction}>Simpan Transaksi</button>
                    
                    {message && <p className="transaction-message">{message}</p>}

                    {/* ✅ Daftar transaksi hari ini dengan delete */}
                    <h3 className="transaction-title">📋 Transaksi Hari Ini</h3>
                    <ul className="transaction-list">
                        {transactionsToday.length > 0 ? (
                            transactionsToday.map((item, index) => (
                                <li key={index} className="transaction-card">
                                    <div className="transaction-header">
                                        <b>Transaksi ke-{index + 1}</b>
                                        <button className="delete-btn" onClick={() => handleDeleteTransaction(item.transaction_id)}>
                                            🗑️
                                        </button>
                                    </div>
                                    <div className="transaction-info">
                                        {item.details}
                                    </div>
                                    <div className="transaction-price">
                                        <b>Total: Rp {item.total_price ? item.total_price.toLocaleString() : "0"}</b>
                                    </div>
                                </li>
                            ))
                        ) : (
                            <p className="no-transaction">Tidak ada transaksi hari ini.</p>
                        )}
                    </ul>


                </div>
            </div>
        </div>
    );
};

export default PosPage;
